/* jshint browserify: true */
'use strict';

import constants from './constants';
import MathJaxRenderer from './Renderers/mathjaxRenderer';
import BasicRenderer from './Renderers/basicRenderer';

const mathRendererFactory = {};

mathRendererFactory.create = function (mathRenderer) {
    if (!mathRenderer || mathRenderer === constants.MATH_RENDERER_MATHJAX) {
        return new MathJaxRenderer();
    } else if (mathRenderer === constants.MATH_RENDERER_BASIC) {
        return new BasicRenderer();
    }
};

export default mathRendererFactory;
